import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import authReducer from '../redux/reducers/authReducer';
import uiReducer from '../redux/slices/uiSlice';
import userReducer from '../redux/slices/userSlice';
import oemReducer from '../redux/reducers/oemReducer';
import dashboardReducer from '../redux/reducers/dashboardReducer';
import revenueReducer from '../redux/reducers/revenueReducer';
import transactionReducer from '../redux/reducers/transactionReducer';
import couponReducer from '../redux/reducers/couponReducer';
import oemScanReducer from '../redux/reducers/oemScanReducer';
import scanReducer from '../redux/reducers/scanReducer';
import profileReducer from '../redux/reducers/profileReducer';
import rootSaga from '../redux/sagas/rootSaga/rootSaga';
import countryReducer from '../redux/reducers/countryReducer';
import oemscanlistReducer from '../redux/reducers/oemscanlistReducer';

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: {
    auth: authReducer,
    ui: uiReducer,
    user: userReducer,
    oem: oemReducer,
    dashboard: dashboardReducer,
    revenue: revenueReducer,
    transaction: transactionReducer,
    coupon: couponReducer,
    oemScan: oemScanReducer,
    scan: scanReducer,
    profile: profileReducer,
    country: countryReducer,
    oemscanlist: oemscanlistReducer,

  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    }).concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);

export default store;